import { h } from 'preact'

import { IconComponentProps } from './index'

export default ({ width = 16, height = 16, color = 'currentColor' }: IconComponentProps) => <svg width={width} height={height} viewBox='0 0 16 16'>
    <path d='M10.0003 7.99999C11.4737 7.99999 12.667 6.80666 12.667 5.33332C12.667 3.85999 11.4737 2.66666 10.0003 2.66666C8.52699 2.66666 7.33366 3.85999 7.33366 5.33332C7.33366 6.80666 8.52699 7.99999 10.0003 7.99999ZM4.00033 6.66666V4.66666H2.66699V6.66666H0.666992V7.99999H2.66699V9.99999H4.00033V7.99999H6.00033V6.66666H4.00033ZM10.0003 9.33332C8.22032 9.33332 4.66699 10.2267 4.66699 12V13.3333H15.3337V12C15.3337 10.2267 11.7803 9.33332 10.0003 9.33332Z' fill={color}/>
</svg>

